import { container, whiteColor } from 'assets/jss/material-dashboard-pro-react';
import backgroundStyle from './backgroundStyle';

const pagesStyle = (theme, ...props) => ({
	...backgroundStyle(theme, ...props),
	relative: {
		position: 'relative',
	},
	footer: {
		position: 'absolute',
		bottom: -30,
		[theme.breakpoints.down('xs')]: {
			bottom: -45,
		},
		[theme.browser.IE]: {
			left: 0,
			width: '100%',
			textAlign: 'center',
			[theme.breakpoints.only('sm')]: {
				width: '100vw',
			},
		},
	},
	wrapper: {
		height: 'auto',
		minHeight: '100vh',
		position: 'relative',
		top: '0',
		paddingBottom: 50,
	},
	fullPage: {
		padding: '0',
		position: 'relative',
		minHeight: '100vh',
		display: 'flex!important',
		margin: '0',
		border: '0',
		color: whiteColor,
		alignItems: 'center',
		backgroundSize: 'cover',
		backgroundPosition: 'center center',
		height: '100%',
	},
	container: {
		...container,
		zIndex: '4',
		width: '100% !important',
		maxWidth: 1200,
	},
	buttonContainer: {
		textAlign: 'right',
		marginTop: 8,
		'& button': {
			fontSize: theme.language === 'ar' ? 12 : 16,
		},
	},
	cardHidden: {
		opacity: '0',
		transform: 'translate3d(0, -60px, 0)',
	},
	cardText: {
		'& > *': {
			[theme.breakpoints.up('md')]: {
				width: '95%',
				marginLeft: 'auto',
				marginRight: 'auto',
			},
		},
	},
	logo: {
		marginTop: 9,
		marginBottom: 0,
	},
	pictureContainer: {
		textAlign: 'right',
		'& img': {
			marginTop: 24,
			height: 'calc(100% - 48px)',
		},
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
	card: {
		paddingLeft: '38px',
		overflow: 'hidden',
		[theme.breakpoints.down('md')]: {
			paddingLeft: 0,
		},
	},
	bodyWrapper: {
		marginLeft: 0,
		[theme.breakpoints.up('xs')]: {
			maxWidth: '280px',
		},
		[theme.breakpoints.up('sm')]: {
			maxWidth: '288px',
		},
		[theme.breakpoints.up('md')]: {
			maxWidth: '292px',
		},
		[theme.breakpoints.up('lg')]: {
			maxWidth: '328px',
		},
		[theme.breakpoints.down('md')]: {
			margin: '0 auto',
		},
	},
});

export default pagesStyle;
